import { addAsset } from '../components/utilities';
import Webforms from './webforms';

const CartDrawer = {
  root: document.querySelector('#component-cart-drawer-root'),
  buttons: document.querySelectorAll('[data-toggle-cart]'),
  countWrapper: document.querySelector('[data-cart-count]'),
  settings: window.cartDrawerSettings || false,

  setCartDrawer: function () {
    const { settings, root } = CartDrawer;

    if (!root || !settings) return;

    const cashbackValue = settings.cashbackValue > 1 ? settings.cashbackValue : 0;

    // Inicia o componente
    const componentCartDrawer = new Vnda.Component.CartDrawer({
      anchor: 'right',
      display: 'list',
      startOpen: false,
      titleCart: 'Carrinho de compras',
      titleSuggested: window.cartDrawerSettings.titleSuggested,
      suggestedProductsTag: 'sugestoes-carrinho',
      disableShippingCalculation: true,
      cashbackValue
    });

    // Renderiza o componente
    componentCartDrawer.render(root);

    // Salva instância para acesso global
    window.cartDrawerSettings.instance = componentCartDrawer;
    CartDrawer.settings = window.cartDrawerSettings;

    // dispara evento de carregamento, escutado por CartDrawer.show()
    root.dispatchEvent(new Event('vnda:cart-drawer-loaded'));
  },

  loadComponent: function () {
    const { settings } = CartDrawer;
    addAsset(settings.script, CartDrawer.setCartDrawer);
    addAsset(settings.styles);
  },

  handleCartButton: function (button) {
    // Evita múltiplos cliques caso o carrinho precisa ser instanciado primeiro
    if (button.classList.contains('-loading')) {
      return;
    }

    // Abre o cart drawer
    button.classList.add('-loading');
    CartDrawer.show(() => {
      button.classList.remove('-loading');
    });
  },

  show: function (callback) {
    const { root } = CartDrawer;

    // No mobile, fecha o menu primeiro
    if (window.mmenu) window.mmenu.close();

    // Instancia o componente, caso ainda não exista
    if (!CartDrawer.settings.instance) CartDrawer.loadComponent();

    // Observa criação da instância inicial, caso não tenha
    if (CartDrawer.settings.instance === false) {
      root.addEventListener('vnda:cart-drawer-loaded', () => {
        CartDrawer.settings.instance.open();
        if (typeof callback === 'function') callback();
      });
    } else {
      // Já possui cart drawer instanciado, retorna abertura
      CartDrawer.settings.instance.open();
      if (typeof callback === 'function') callback();
    }
  },

  getCartItens: async function () {
    try {
      const response = await fetch('/carrinho/itens');
      const itens = await response.json();
      return itens;
    } catch (error) {
      console.error('Erro ao buscar a quantidade de produtos do carrinho');
      console.error(error);
      return 0;
    }
  },

  updateCartCount: async function (_itemsCount = null) {
    let items = _itemsCount;
    if (_itemsCount == null) items = await CartDrawer.getCartItens();

    this.countWrapper.innerHTML = items;
  },

  budget: function () {
    const root = document.querySelector('#component-cart-drawer-root'),
          selectorItem = '.cart-item',
          selectorName = '.cart-list-item-name a',
          selectorPrice = '.cart-list-item-price',
          selectorAmount = '.cart-buttons-amount'
    
    if (root) {
      window.lastAmount = 0;

      // to reset empty cart
      let reset = () => { window.lastAmount = 0; }

      // create cart observer
      let observer = new MutationObserver(() => {

        // get amount elements
        let amounts = root.querySelectorAll(selectorAmount);
        if (!amounts.length) return reset();

        // set current amount
        let currentAmount = 0;
        amounts.forEach(amount => { currentAmount += Number(amount.innerText) });
        
        console.log('last', window.lastAmount);
        console.log('current', currentAmount);

        // verify last amount
        if (window.lastAmount != currentAmount) {
          window.lastAmount = currentAmount;

          // get cart json
          vnda.loadCartPopup(async (json) => {
            let cart = await JSON.parse(json);

            // get items element & items json
            let itemsElement = root.querySelectorAll(selectorItem);
            let itemsJson = cart.items;
            if (!itemsElement.length || !itemsJson.length) return;

            // iterate items
            let budgetTags = false;
            let budgetProducts = '';
            itemsElement.forEach(itemElement => {
              let name = itemElement.querySelector(selectorName).innerText;
              let amount = itemElement.querySelector(selectorAmount).innerText;

              // save item name
              budgetProducts +=
                budgetProducts == ''
                  ? `${name}: ${amount}`
                  : ` | ${name}: ${amount}`

              // verify item name & item tags
              itemsJson.forEach(itemJson => {
                if (itemJson.product_name == name && itemJson.tags.length)
                  
                  // verify item tags
                  itemJson.tags.forEach(tag => {

                    // verify budget tags
                    if (tag.name.includes('orcamento'))
                      budgetTags = true;

                    // verify no price tag
                    if (tag.name == 'orcamento-sem-preco') {

                      // remove item price
                      itemElement.querySelector(selectorPrice).classList.add('-hidden');
                      itemElement.querySelector(selectorPrice).innerHTML = 0;
                    }
                  });
              });
            });
          });
        }
      });

      // initialize cart observer
      observer.observe(root, { childList: true, subtree: true });
    }
  },

  init: function () {
    const _this = this;
    const { buttons } = _this;

    // Atualiza o contador de itens do carrinho
    _this.updateCartCount();
    _this.budget();

    if (buttons.length > 0)
      buttons.forEach((button) => {
        button.addEventListener('click', () => {
          _this.handleCartButton(button);
        });
      });
  },
};

export default CartDrawer;
